import Lottie from 'lottie-react';

import terminalApprove from '../../assets/lottie/terminal-approve.json';
import terminalDecline from '../../assets/lottie/terminal-decline.json';
import terminalCompletePurchase from '../../assets/lottie/terminal-complete-purchase.json';

import { TerminalProps } from './types';

const commonProps = {
  loop: false,
  width: '100%',
  height: '100%',
  autoPlay: true,
};

export const TerminalCompletePurchase = ({ onComplete }: TerminalProps) => (
  <Lottie
    {...commonProps}
    onComplete={onComplete}
    animationData={terminalCompletePurchase}
  />
);

export const TerminalApprove = ({ onComplete }: TerminalProps) => (
  <Lottie
    {...commonProps}
    onComplete={onComplete}
    animationData={terminalApprove}
  />
);

export const TerminalDecline = ({ onComplete }: TerminalProps) => (
  <Lottie
    {...commonProps}
    onComplete={onComplete}
    animationData={terminalDecline}
  />
);
